'use client';
import e$1 from 'prop-types';
import * as e from 'react';
import { useSelectionSetContext, SelectionSetInputContext } from './selection-set.context.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { useId } from '../../hooks/use-id.js';
import { composeEventHandlersUtil } from '../../utilities/compose-event-handlers.util.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, o = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), o.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function ownKeys(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r.push.apply(r, o);
    }
    return r;
}
function _object_spread_props(e, t) {
    return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    }), e;
}
let s = {
    value: e$1.string.isRequired
}, i = [];
const SelectionSetInput = renderWithRef('SelectionSetInput', s, (e$1, o)=>{
    let { value: s, children: l, id: u, onChange: b } = e$1, f = useSelectionSetContext(), m = useId(u), d = 'multi-select' === f.variant, y = d ? f.selectedValues[s] : f.selectedValue === s, O = d ? (e)=>{
        f.onSelectedValuesChange(_object_spread_props(_object_spread({}, f.selectedValues), {
            [s]: e.target.checked
        }), e);
    } : (e)=>{
        e.target.checked && f.onSelectedValueChange(s, e);
    }, j = _object_spread_props(_object_spread({
        type: d ? 'checkbox' : 'radio'
    }, e$1), {
        id: m,
        name: f.name,
        value: s,
        checked: y,
        onChange: composeEventHandlersUtil(b, O)
    });
    return e.createElement(e.Fragment, null, e.createElement(RenderComp, {
        root: "input",
        forwardedRef: o,
        propKeysToRemove: i,
        classNames: [
            'swan-selection-set-input',
            d ? 'swan-checkbox' : 'swan-radio'
        ],
        props: j
    }), e.createElement(SelectionSetInputContext.Provider, {
        value: {
            selectionSetInputId: m
        }
    }, l));
});

export { SelectionSetInput };
